import ProductMixGraph from "../../../../../graphs/ProductMixGraph";
import ModeOfTransportGraph from "../../../../../graphs/ModeOfTransportGraph";
import TitleTransferGraph from "../../../../../graphs/TitleTransferGraph";
import ShipmentsTable from "../../../../../graphs/Shipments";
import LocationQty from "../../../../../graphs/LocationQty";
import AccountTable from "../../../../../graphs/Account";

const ActivityDashboardTab = () => {
  return (
    <div
      style={{
        padding: "0px 30px",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",

        gap: 20,
        paddingBottom: 40,
      }}
    >
      <ShipmentsTable />

      <div
        style={{
          display: "flex",
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <div style={{ width: "calc((100% - 20px) / 2)" }}>
          <ProductMixGraph />
        </div>
        <div style={{ width: "calc((100% - 20px) / 2)" }}>
          <ModeOfTransportGraph />
        </div>
      </div>

      <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
        <div style={{ width: "calc((100% - 20px) / 2)" }}>
          <TitleTransferGraph />
        </div>

        <div style={{ width: "calc((100% - 20px) / 2)" }}>
          <AccountTable />
        </div>
      </div>

      <LocationQty />
    </div>
  );
};

export default ActivityDashboardTab;
